import React from "react";
import "./Plane.css";
import plane from "../../img/about/plane.png";

function Plane() {
  return (
    <div className="Plane">
   <div className="Plane__mobile__img">
   <img src={plane} alt="Luxury villa with sea view in Costa Blanca, Spain" />
   </div>
      <div className="Plane__txt">
        <h1>airports and trains</h1>
        <p>
          Close Airports and Trains: Accessibility is key in Costa Blanca, with
          convenient access provided by several international airports,
          including Alicante-Elche Airport and Valencia Airport, ensuring
          seamless travel for visitors from around the globe.
          <br />
          <br />
          The train also offers a convenient and reliable transportation options
          for both residents and visitors: the Denia Line offers a convenient
          and scenic way to travel between Denia and Alicante, allowing
          passengers to enjoy the beautiful coastal landscapes of the Costa
          Blanca region
        </p>
      </div>
      <div className="Plane__img">
        <img src={plane} alt="Luxury villa with sea view in Costa Blanca, Spain" />
      </div>
    </div>
  );
}

export default Plane;
